import {
  WeeklyDinnerItem,
  weeklyDinnerItemsSchema,
  WeeklyDinnerItemUpdate,
} from "@mjolnerbacken/shared/types/weekly-dinner-item";

import { FETCH_ERROR } from "../consts/fetch-error";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getWeeklyDinnerItems(): Promise<WeeklyDinnerItem[]> {
  const response = await fetch(`${API_BASE_URL}/weekly-dinner-items`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  }

  const data = (await response.json()) as unknown;
  return weeklyDinnerItemsSchema.parse(data);
}

export async function updateWeeklyDinnerItem(
  id: string,
  update: WeeklyDinnerItemUpdate,
): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/weekly-dinner-items/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(update),
  });

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  }
}
